import { API_HOST, getHttpGetOptions, getHttpPostOptions } from '../../../utils/api-util';

const getEndpoint = () => `${API_HOST}/admin/account-management`;

const getRetrieveAccountsEndpoint = () => `${getEndpoint()}/retrieve-accounts`;
export const getRetrieveAccountsRequest = (filters) => [getRetrieveAccountsEndpoint(), getHttpPostOptions(filters)];

const getFindAccountEndpoint = (externalReference) => `${getEndpoint()}/find-account/${externalReference}`;
export const getFindAccountRequest = (externalReference) => [
  getFindAccountEndpoint(externalReference),
  getHttpGetOptions(),
];

const getReviewCompanyDocumentsEndpoint = () => `${getEndpoint()}/review-company-documents`;
export const getReviewCompanyDocumentsRequest = (document) => [
  getReviewCompanyDocumentsEndpoint(),
  getHttpPostOptions(document),
];

const getUploadCompanyDocumentEndpoint = () => `${getEndpoint()}/upload-company-documents`;
export const getUploadCompanyDocumentRequest = (document) => [
  getUploadCompanyDocumentEndpoint(),
  getHttpPostOptions(document),
];
